import { Observable } from 'rxjs';
import { CredentialsApi, Login } from 'src/app/hickory-api';
import { mockHandler } from '../mock.handler';

export class MockCredentialsApi extends CredentialsApi {

  private credentials: any = {
    CredentialsId: 1010,
    Username: 'royal.fort@alertsense.com',
    Email: 'royal.fort@alertsense.com',
    AuthToken: '2ffa6a7b-763b-4f8e-ad1e-825310dcfed6',
    MaxExpiredTime: '/Date(-62135596800000-0000)/'
  }

  postLogin(body: Login): Observable<any> {
    return mockHandler(this.credentials);
  }
}
